<template>
  <app-base-sheet ref="sheet">
    <template v-slot:title> Сортування </template>
    <template v-slot:content>
      <div class="sort-options">
        <app-radio
          v-for="option in sortOptions"
          :key="option.value"
          :value="option.value"
          v-model="selectedOption"
        >
          {{ option.label }}
        </app-radio>
      </div>
    </template>
  </app-base-sheet>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useStore } from "vuex";
import AppBaseSheet from "@/components/common/ui/AppBaseSheet.vue";
import AppRadio from "@/components/common/ui/AppRadio.vue";
import { eventBus, events } from "@/eventBus";
import { mutationTypes as shopMutationTypes } from "@/store/modules/shop";

export default {
  name: "ShopSortingSheetComponent",
  components: {
    AppBaseSheet,
    AppRadio,
  },
  setup() {
    const sheet = ref(null);
    const store = useStore();

    const selectedOption = computed({
      get: () => store.getters["shop/sortOption"],
      set: (val) => {
        store.commit(`shop/${shopMutationTypes.SET_SORT_OPTION}`, val);
      },
    });

    const sortOptions = [
      { label: "За зростанням ціни", value: "price_asc" },
      { label: "За зменшенням ціни", value: "price_desc" },
    ];

    watch(selectedOption, () => {
      sheet.value?.close();
    });

    onMounted(() => {
      eventBus.$on(events.OPEN_SHEET_SHOP_SORTING, () => {
        sheet.value?.open();
      });
    });

    onUnmounted(() => {
      eventBus.$off(events.OPEN_SHEET_SHOP_SORTING);
    });

    return {
      sheet,
      sortOptions,
      selectedOption,
    };
  },
};
</script>

<style scoped lang="less">
.sort-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}
</style>
